<template>
    <div class="divider">
        <div class="divider-title">{{dividerTitle}}</div>
    </div>
</template>
<script>
    export default {
        name: 'Divider',
        components: {},
        props: {
            dividerTitle: {
                type: String,
                default: 'title',
                description: 'Give title of divider'
            }
        },
        data () {
            return {

            }
        },
        computed: {

        },
        mounted () {

        },
        methods: {

        }
    }

</script>
<style src="./Divider.scss" scoped lang="scss"></style>

